import { FC } from "react"
import { Activity, Palette } from "lucide-react"
import { Integration } from "../../../../../types"
import SectionCard from "../../../section-card"
import { Colors, GoogleAnalyticsTag } from "../../fields"

interface Props {
  integration?: Integration
  includeAnalytics?: boolean
}

const BrandingAnalyticsSection: FC<Props> = ({
  integration,
  includeAnalytics = true
}) => {
  if (!includeAnalytics) {
    return (
      <SectionCard icon={<Palette size={15} />} title="Branding">
        <Colors integration={integration} />
      </SectionCard>
    )
  }

  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-[1fr_320px]">
      <SectionCard icon={<Palette size={15} />} title="Branding">
        <Colors integration={integration} />
      </SectionCard>
      <SectionCard icon={<Activity size={15} />} title="Analytics">
        <GoogleAnalyticsTag integration={integration} />
      </SectionCard>
    </div>
  )
}

export default BrandingAnalyticsSection
